module.exports = __webpack_public_path__ + "img/xiaofang.76ffe826.svg";